var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { header: true, container: true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.canShowMorePlans
        ? _c(
            "button",
            {
              staticClass: "plan-btn header-btn",
              class: {
                "desktop-hide": !_vm.useMobileStyling && _vm.showingAllPlans,
                "mobile-hide": _vm.useMobileStyling && _vm.showingAllPlans
              },
              on: { click: _vm.handleClick }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.buttonText))]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  attrs: {
                    width: "17",
                    height: "16",
                    viewBox: "0 0 17 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    staticClass: "icon",
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M12.8713 7.95711L4.91421 15.9142L3.5 14.5L10.0429 7.95711L3.5 1.41421L4.91421 0L12.8713 7.95711Z",
                      fill: "#666666"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "legal" }, [
        _vm._v(
          "\n    *Billed as one payment. Subscription renews automatically at the end of term. You can turn off\n    auto-renew from your settings.\n    "
        ),
        _c(
          "button",
          {
            staticClass: "legal-btn header-btn",
            on: {
              click: function($event) {
                _vm.showLegal = true
              }
            }
          },
          [_vm._v("Learn more here.")]
        )
      ]),
      _vm._v(" "),
      _vm.showLegal
        ? _c("PaywallSubscriptionNotice", {
            on: {
              close: function($event) {
                _vm.showLegal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: { plans: true, mobile: _vm.isMobile(_vm.$mq) },
          attrs: { id: "plans-container" }
        },
        [
          _vm.showingAllPlans || !_vm.useMobileStyling
            ? _c(
                "div",
                {
                  staticClass: "monthly-plans",
                  class: {
                    back: !_vm.isMobile(_vm.$mq),
                    left: !_vm.isMobile(_vm.$mq)
                  }
                },
                [
                  _vm.monthlyPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.monthlyPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paywallPlans.threeMonthPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.paywallPlans.threeMonthPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paywallPlans.sixMonthPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.paywallPlans.sixMonthPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paywallPlans.annualPlan
            ? _c(
                "div",
                {
                  staticClass: "plan popular",
                  class: {
                    front: !_vm.isMobile(_vm.$mq),
                    expanded: _vm.showingAllPlans
                  },
                  attrs: {
                    "data-price-vendor":
                      _vm.paywallPlans.annualPlan.price_vendor
                  },
                  on: { click: _vm.handleAnnualClick }
                },
                [
                  _vm.useMobileStyling
                    ? _c("div", { staticClass: "mobile-plan" }, [
                        _c("span", [_vm._v(" 1 Year ")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.strikeThroughPrice
                            ? _c("s", { staticClass: "original" }, [
                                _vm._v(_vm._s(_vm.strikeThroughPrice))
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.paywallPlans.annualPlan.display_price
                              ) +
                              "\n          "
                          ),
                          _c("small", [_vm._v("/month*")])
                        ])
                      ])
                    : _c("div", { staticClass: "plan-card" }, [
                        _c("h4", [_vm._v("Annual")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price" }, [
                          _c("h5", [
                            _vm.strikeThroughPrice
                              ? _c("s", { staticClass: "original" }, [
                                  _vm._v(_vm._s(_vm.strikeThroughPrice))
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.paywallPlans.annualPlan.display_price
                                ) +
                                "\n            "
                            ),
                            _c("small", [_vm._v("/month*")])
                          ]),
                          _vm._v(" "),
                          _vm.paywallPlans.annualPlan.renewal_price &&
                          !_vm.paywallPlans.annualPlanIncludesReferralDiscount
                            ? _c("span", [
                                _c("small", [
                                  _vm._v(
                                    "for the first year, then " +
                                      _vm._s(
                                        _vm.paywallPlans.annualPlan
                                          .renewal_price
                                      ) +
                                      "/month*"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSuscribeButton
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: { axId: _vm.axId("annual") },
                                      expression: "{ axId: axId('annual') }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn btn-green",
                                  on: { click: _vm.handleAnnualClick }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.paywall_type === "upgrade"
                                          ? "Switch to annual"
                                          : "Subscribe now"
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showingAllPlans || !_vm.useMobileStyling
            ? _c(
                "div",
                {
                  staticClass: "annual-plans",
                  class: {
                    back: !_vm.isMobile(_vm.$mq),
                    right: !_vm.isMobile(_vm.$mq)
                  }
                },
                [
                  _vm.paywallPlans.twoYearPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.paywallPlans.twoYearPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paywallPlans.threeYearPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.paywallPlans.threeYearPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paywallPlans.fourYearPlan
                    ? _c("PaywallPlan", {
                        attrs: {
                          plan: _vm.paywallPlans.fourYearPlan,
                          upgrade: _vm.paywall_type === "upgrade",
                          "already-lifetime":
                            _vm.paywall_type == "already_lifetime",
                          "on-trial-paywall": true,
                          extended: _vm.showingAllPlans
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paywallPlans.groupPlan &&
                  (_vm.showingAllPlans || !_vm.isMobile(_vm.$mq))
                    ? _c(
                        "div",
                        { staticClass: "group" },
                        [
                          _vm.useMobileStyling
                            ? _c(
                                "PaywallPlanMini",
                                {
                                  attrs: {
                                    axId: "clicked_pay_button_groups",
                                    "data-price-vendor":
                                      _vm.paywallPlans.groupPlan.price_vendor
                                  },
                                  on: {
                                    "plan-clicked": function($event) {
                                      return _vm.handleSubscribeNowClick(
                                        _vm.paywallPlans.groupPlan.checkout_url
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      attrs: { slot: "plan-name" },
                                      slot: "plan-name"
                                    },
                                    [_vm._v("Groups of 3+")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    {
                                      attrs: { slot: "plan-price" },
                                      slot: "plan-price"
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.paywallPlans.groupPlan
                                              .display_price
                                          ) +
                                          "\n            "
                                      ),
                                      _c("small", [_vm._v("/year")])
                                    ]
                                  )
                                ]
                              )
                            : _c("div", { staticClass: "plan" }, [
                                _c("div", { staticClass: "plan-card" }, [
                                  _c("h4", [_vm._v("Groups of 3+")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "price" }, [
                                    _c("h5", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.paywallPlans.groupPlan
                                              .display_price
                                          ) +
                                          "\n                "
                                      ),
                                      _c("small", [_vm._v("/year")])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "track",
                                            rawName: "v-track:click",
                                            value: {
                                              axId: "clicked_pay_button_groups",
                                              axType: "button"
                                            },
                                            expression:
                                              "{\n                  axId: 'clicked_pay_button_groups',\n                  axType: 'button',\n                }",
                                            arg: "click"
                                          }
                                        ],
                                        staticClass: "btn btn-green",
                                        attrs: {
                                          href:
                                            _vm.paywallPlans.groupPlan
                                              .checkout_url,
                                          "data-price-vendor":
                                            _vm.paywallPlans.groupPlan
                                              .price_vendor
                                        },
                                        on: { click: _vm.trackAddToCart }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Subscribe now\n              "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.useMobileStyling
        ? _c("BeakerAndFlaskSvg", { staticClass: "beaker-and-flask" })
        : _vm._e(),
      _vm._v(" "),
      !_vm.useMobileStyling
        ? _c("RoundBottomFlask", { staticClass: "flask" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-text" }, [
      _c("h2", [_vm._v("Unlock the full Brilliant experience")]),
      _vm._v(" "),
      _c("p", { staticClass: "sub-header" }, [
        _vm._v(
          "\n      Get unlimited access to all math, science, and computer science courses on Brilliant.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }